import React from 'react';
import styles from './description.module.scss';

export default function Description({text}:{text:string}) {
	return <p className={styles.description}>{text}</p>
}